module.exports = __webpack_public_path__ + "static/media/french-polynesia.5e1c248f.svg";